import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogRef } from '@rd/popup/dialog-ref';
import { SuccessButton } from '@rd/types';
import { RedeemCashSettingService } from '../../services/redeem-cash-setting/redeem-cash-setting.service';

@Component({
  selector: 'rd-rcv2-membership-failed-dialog',
  templateUrl: './membership-failed-dialog.component.html',
  styleUrls: ['./membership-failed-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RcV2MembershipFailedDialogComponent implements OnInit {
  @HostBinding('class.rd-rcv2-membership-failed-dialog') componentClass = true;

  failedLinkedDialogButton: SuccessButton;

  constructor(
    private dialogRef: DialogRef,
    private iconRegistryService: IconRegistryService,
    private redeemCashSettingService: RedeemCashSettingService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
    this.failedLinkedDialogButton =
      this.redeemCashSettingService.failedLinkedDialogButton;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('warning');
  }
}
